import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// Scrolls to the top on every link navigation (including re-clicking the current page),
// but keeps the browser's own scroll restoration for back/forward.
export const ScrollToTop: React.FC = () => {
  const { key, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;
    if (hash) {
      document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [key, hash, navigationType]);

  return null;
};
